/// <reference types="@types/google.maps" />

import {setOptions, importLibrary} from '@googlemaps/js-api-loader';

const API_KEY = 'AIzaSyCTQgFnixtKUNFecbQRs1hNSCniaUzTuUk';

async function initMap(): Promise<void> {
    setOptions({key: API_KEY, v: 'weekly'});

    try {
        const {Map, InfoWindow} = await importLibrary('maps') as google.maps.MapsLibrary;
        const {AdvancedMarkerElement} = await importLibrary('marker') as google.maps.MarkerLibrary;

        let location = (window as any).maps_data;

        if (!location) {
            location = {lat: 52.570588, lng: 5.651719};
        }

        const mapOptions: google.maps.MapOptions = {
            center:location,
            zoom: 13,
            mapId: '1ed5954cd88b5113a124d101',
        };

        const mapElement = document.getElementById('google-maps');
        if (!mapElement) return;

        const map = new Map(mapElement, mapOptions);

        const marker = new AdvancedMarkerElement({
            map: map,
            position: mapOptions.center,
            title: 'VM Service',
        });
    } catch (error) {
        console.error("Error loading Google Maps:", error);
    }
}

initMap();